import ModalDlg from 'components/Basic/ModalDlg';
import { FormattedMessage, injectIntl } from 'react-intl';
import { compose } from 'react-recompose';
import moment from 'moment-timezone';
import * as dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import placeHolderImg from 'assets/img/placeholder.svg';
import { Tabs, Divider, Card, Button } from 'antd';
import { useEffect, useState } from 'react';
import { getCurrency, getProductInfo } from 'utilities/common';
import { CloseOutlined } from '@ant-design/icons';
// import { Img } from 'react-image';
import { getMealType } from 'utilities/transformDateTime';
const { TabPane } = Tabs;

dayjs.extend(utc);
dayjs.extend(timezone);

function ShippingCostViewModal({ intl, shippingCostInfo, isOpenModal, onCloseModal }) {
  if (!shippingCostInfo) return null;

  const [error, setError] = useState(false);

  const getProduct = data => {
    return getProductInfo(data, [], []);
  };

  const items = [
    {
      label: intl.formatMessage({ id: 'Product' }) + ' 1',
      key: '1',
      children: intl.formatMessage({ id: 'Add item details' }),
    },
  ];
  const [tabItem, setTabItem] = useState(items);

  useEffect(() => {
    let startDate = moment(shippingCostInfo?.startDate).tz('America/Guatemala');
    console.log('startDate', startDate);

    if (shippingCostInfo?.RestaurantShippingCost && Array.isArray(shippingCostInfo?.RestaurantShippingCost)) {
      const label = intl.formatMessage({ id: 'Product' });
      const newItems = shippingCostInfo?.RestaurantShippingCost.map((item, index) => {
        let codeImage =
          item?.product?.productCode > 0 ? item?.product?.productCode : getProduct(item).productCode || item.sku;

        console.log('codeImage', codeImage);

        const src =
          codeImage !== undefined
            ? `${process.env.REACT_APP_S3}/${item?.product?.channel === 'APP' ? 'customer' : 'ots'}/${
                item?.product?.productCode > 0 ? item?.product?.productCode : getProduct(item).productCode || item.sku
              }.jpg`
            : placeHolderImg;

        console.log('src', src);

        return {
          label: `${label} ${index + 1}`,
          key: `${index + 1}`,
          children: (
            <div className="tabs_products">
              <div className="priority">
                <p className="priority__title">{intl.formatMessage({ id: 'priority' })}</p>
                <p className="priority__value">{item.priority}</p>
              </div>

              <div className="product">
                <p className="product__title">{intl.formatMessage({ id: 'Product' })}</p>
                <div className="product__value">
                  <img
                    className="image__value"
                    src={error ? placeHolderImg : src}
                    alt={item.name}
                    onError={() => setError(true)}
                  />

                  <div className="productName">
                    ID: {item?.product?.id}, SKU: {item?.product?.sku}&nbsp;- &nbsp;
                    <span dangerouslySetInnerHTML={{ __html: item?.product?.name }} />
                    &nbsp;&nbsp;
                    {getCurrency().symbol}
                    {(item?.product?.price / 100).toFixed(2)}
                  </div>
                </div>
              </div>
            </div>
          ),
        };
      });

      setTabItem(newItems);
    } else {
      setTabItem(items);
    }
  }, [shippingCostInfo, intl]);

  const typeToTranslate = type => {
    let split = type.split('-');
    return split.map(part => intl.formatMessage({ id: part })).join(' - ');
  };

  return (
    <ModalDlg
      className="shippingCost_view_modal"
      visible={isOpenModal}
      width={700}
      handleCancel={onCloseModal}
      isCenter
    >
      <div className="modal_header">
        <h3>
          <FormattedMessage id="ShippingCost" />
        </h3>
        <Button className="btn_close_modal" onClick={onCloseModal}>
          <CloseOutlined />
        </Button>
      </div>
      <div className="modal_content">
        <Card className="divider_card">
          <p className="title">
            <FormattedMessage id="Where will they be shown" />
          </p>
          <Divider />
          <div className="section_restaurant">
            <div className="restaurant">
              <div className="restaurant__title">
                <FormattedMessage id="Restaurant" />
              </div>
              <div className="restaurant__value">
                {shippingCostInfo?.RestaurantShippingCost[0]?.restaurant?.map((restaurant, index) => (
                  <div key={index}>{restaurant.description}</div>
                ))}
              </div>
            </div>
          </div>
        </Card>
        <Card className="divider_card">
          <p className="title">
            <FormattedMessage id="What elements will be shown" />
          </p>
          <Divider />
          <div className="section_product">
            <Tabs defaultActiveKey="1" className="shipping_cost_view_tabs">
              {tabItem.map(item => (
                <TabPane tab={item.label} key={item.key}>
                  {item.children}
                </TabPane>
              ))}
            </Tabs>
          </div>
        </Card>
        <Card className="divider_card">
          <p className="title">
            <FormattedMessage id="Rules" />
          </p>
          <Divider />
          <div className="section_timesheet2">
            <div className="timesheet2">
              <p className="minimum_amount__title">
                <FormattedMessage id="start_time" />
              </p>
              <p className="minimum_amount__value">{shippingCostInfo?.openTime}</p>
            </div>
            <div className="timesheet2">
              <p className="part_time__title">
                <FormattedMessage id="Finish time" />
              </p>
              <p className="part_time__value">{shippingCostInfo?.closeTime}</p>
            </div>
          </div>
          <div className="section_timesheet2">
            <div className="timesheet2">
              <p className="minimum_amount__title">
                <FormattedMessage id="Minimum amount" />
              </p>
              <p className="minimum_amount__value">
                {getCurrency().symbol}
                {shippingCostInfo?.minimalShippingCost / 100}
              </p>
            </div>
            <div className="timesheet2">
              <p className="part_time__title">
                <FormattedMessage id="Part time" />
              </p>
              <p className="part_time__value">
                {typeToTranslate(getMealType(shippingCostInfo?.openTime, shippingCostInfo?.closeTime))}
              </p>
            </div>
          </div>
        </Card>
      </div>
    </ModalDlg>
  );
}

ShippingCostViewModal.defaultProps = {
  isOpenModal: false,
  shippingCostInfo: {},
};

export default compose(injectIntl)(ShippingCostViewModal);
